import React, { lazy, Suspense } from 'react';
import { MapPin, Copy, ExternalLink } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { generateGoogleMapsLink } from '../../MapView';

const MapView = lazy(() => import('../../MapView'));

export const DeliveryMapSection = ({ stops, onCopyLink, onClose }) => {
    if (!stops || stops.length === 0) return null;

    return (
        <Card className="mb-4" data-testid="delivery-map-card">
            <CardHeader className="pb-2">
                <div className="flex items-center justify-between">
                    <CardTitle className="text-lg text-jungle flex items-center gap-2">
                        <MapPin className="h-5 w-5" />
                        Carte de livraison ({stops.length} points)
                    </CardTitle>
                    <div className="flex gap-2">
                        <Button size="sm" variant="outline" className="rounded-xl" onClick={onCopyLink} data-testid="copy-maps-link">
                            <Copy className="h-4 w-4 mr-1" /> Copier lien Maps
                        </Button>
                        <a
                            href={generateGoogleMapsLink(stops)}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Button size="sm" className="bg-jungle text-white rounded-xl" data-testid="open-maps-btn">
                                <ExternalLink className="h-4 w-4 mr-1" /> Ouvrir Google Maps
                            </Button>
                        </a>
                        <Button size="sm" variant="ghost" onClick={onClose}>Fermer</Button>
                    </div>
                </div>
            </CardHeader>
            <CardContent>
                <Suspense fallback={<div className="h-96 bg-muted animate-pulse rounded-xl" />}>
                    <MapView markers={stops} height="400px" />
                </Suspense>
            </CardContent>
        </Card>
    );
};
